import api from './api';

const ENDPOINT = 'campaigns';

const CampaignService = {
  getId: (id) => api.get(`${ENDPOINT}/${id}`),
  getByNetwork: (networkId, params = {}) =>
    api.get(`${ENDPOINT}/get-by-network`, { params: { networkId, ...params } }),
  search: (params) => api.get(`${ENDPOINT}/search`, { params }),
};

export default CampaignService;
